import React from 'react';
import './Contato.css';

const Contato = () => {
  return (
    <section className="contact-section">
      <div className="contact-card">
        <h2 className="section-title">Contato</h2>
        <p className="contact-description">
          Ficou com alguma dúvida? Gostaria de agendar uma visita? Entre em contato conosco!<br /><br />
          Priorizamos o atendimento por <strong>Whatsapp</strong>, mas e-mail também é uma opção válida!<br /><br />
          Para <strong>novidades e atualizações</strong>, siga nosso perfil no <strong>Instagram</strong>!
        </p>

        <div className="contact-options">
          <div className="contact-item">
            <i className="fa fa-whatsapp contact-icon"></i>
            <p>
              <a
                href="http://wa.me/5515991760482"
                target="_blank"
                rel="noopener noreferrer"
              >
                Converse conosco pelo WhatsApp
              </a>
            </p>
          </div>
          <div className="contact-item">
            <i className="fa fa-envelope contact-icon"></i>
            <p>
              <a href="mailto:clinicafamiliasingular@gmail.com">
                Envie um e-mail para nossa equipe
              </a>
            </p>
          </div>
          <div className="contact-item">
            <i className="fa fa-instagram contact-icon"></i>
            <p>
              <a
                href="https://www.instagram.com/familiasingular"
                target="_blank"
                rel="noopener noreferrer"
              >
                Acompanhe nosso trabalho pelo Instagram
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contato;
